/**
 * V2 Condition Editor Constants
 *
 * Validation messages and conflict detection thresholds.
 * Operator definitions live in v2-variable-utils (SSoT).
 *
 * @module v2-condition-editor
 */

// ============================================================================
// VALIDATION MESSAGES
// ============================================================================

export const V2_VALIDATION_MESSAGES = {
  VARIABLE_REQUIRED: 'Please select a variable',
  OPERATOR_REQUIRED: 'Please select an operator',
  VALUE_REQUIRED: 'Please enter a value',
  INVALID_OPERATOR: 'Selected operator is not valid for this variable type',
  VARIABLE_NOT_FOUND: 'Variable not found — it may have been deleted',
  INVALID_NUMBER: 'Value must be a valid number',
  INVALID_DATE: 'Value must be a valid date',
} as const;

// ============================================================================
// CONFLICT MESSAGES
// ============================================================================

export const V2_CONFLICT_MESSAGES = {
  MUTUAL_EXCLUSION: 'These conditions can never both be true at the same time',
  ALWAYS_FALSE: 'These conditions together always evaluate to false',
  REDUNDANT: 'One of these conditions is redundant — it is already implied by the other',
} as const;

// ============================================================================
// DEFAULTS
// ============================================================================

/** Default condition logic when creating new editor state */
export const DEFAULT_CONDITION_LOGIC = 'and' as const;

/** Default empty condition row template */
export const EMPTY_CONDITION_ROW = {
  key: '',
  operator: '' as const,
  value: '',
  isValid: false,
} as const;
